export enum Feature {
  AMM = 'AMM',
  AMM_V2 = 'AMM V2',
  LIQUIDITY_MINING = 'Liquidity Mining',
  BENTOBOX = 'BentoBox',
  KASHI = 'Kashi',
  MISO = 'MISO',
  ANALYTICS = 'Analytics',
  MIGRATE = 'Migrate',
  STAKING = 'Staking',
  TRIDENT = 'Trident',
  LIMIT_ORDERS = 'LimitOrders',
  INARI = 'Inari',
  MEOWSHI = 'MEOWSHI',
  VESTING = 'Vesting',
  SUSHIGUARD = 'SushiGuard',
}
